module.exports = __webpack_public_path__ + "static/media/button_icon_bye.30a94578.svg";